import React, { useEffect, useState } from 'react'
import { flatten, isEmpty, map } from 'lodash'
import PropTypes from 'prop-types'

import ImageCarousel from '../ImageCarousel'

function DigitalCertificateCarGallery({ certificateData }) {
  const [carConditionImages, setCarConditionImages] = useState([])

  useEffect(() => {
    if (!isEmpty(certificateData)) {
      const {
        technicalConditions: { getTechnicalConditionGroupModel: groups },
      } = certificateData
      setCarConditionImages(
        flatten(
          map(groups, ({ technicalChecklistGroupName, technicalImages }) =>
            map(technicalImages, ({ imageUrl }) => ({
              url: imageUrl,
              name: technicalChecklistGroupName,
            })),
          ),
        ),
      )
    }
  }, [certificateData])

  return isEmpty(carConditionImages) ? null : (
    <ImageCarousel images={carConditionImages} />
  )
}

DigitalCertificateCarGallery.propTypes = {
  certificateData: PropTypes.object,
}
DigitalCertificateCarGallery.defaultProps = {
  certificateData: {},
}
export default DigitalCertificateCarGallery
